import { JOB_TYPE_OPTIONS } from "../../../constants";
import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import type { CrmEnrichmentJobType } from "../../../types/types";
import JobSwitcher from "../JobSwitcher";

const JobTypeSwitcher = ({ type }: { type: CrmEnrichmentJobType }) => {
    const { i18nKeys } = useCrmEnrichmentContext();

    return (
        <JobSwitcher
            options={JOB_TYPE_OPTIONS}
            selectedOption={type}
            getTranslationKey={(typeOption) => i18nKeys.type(typeOption)}
            isDisabled
        />
    );
};

export default JobTypeSwitcher;
